module.exports = __webpack_public_path__ + "img/hide-view.87bacd0e.svg";